import { Autocomplete, Backdrop, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalTable from "../../../../../components/utils/modalTable/modalTable";
import { PictureAsPdf } from "@mui/icons-material";
import { setPDFData } from "../../../../../components/hooks/printPdf/pdfData";
import {  useNavigate } from "react-router-dom";

const StockMissingReports = () => {
  const classes = useStyle()
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [rowData, setRowData] = useState(null)
  const[cust, setCust] = useState(null)
  const[salesLines , setSalesLines] = useState([])
  const [open , setOpen] = useState(false)
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
  const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().subtract(1 , "months").format(),
    toDate :  moment().format()
  })
  const onEdit = (e) => {
    console.log(e.row)
    setSalesLines(e.row.sales_lines)
    setRowData(e.row)
    setOpen(true)
  }
  const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

  const convertNumber = (num) => {
    if (num === 0) return 'Zero';

    let words = '';
    for (let i = 0; num > 0; i++) {
      if (num % 1000 !== 0) {
        words = convertHundreds(num % 1000) + ' ' + thousands[i] + ' ' + words;
      }
      num = Math.floor(num / 1000);
    }
    return words.trim();
  };

  const convertHundreds = (num) => {
    if (num >= 100) {
      return units[Math.floor(num / 100)] + ' Hundred ' + convertTens(num % 100);
    } else {
      return convertTens(num);
    }
  };

  const convertTens = (num) => {
    if (num < 10) return units[num];
    else if (num < 20) return teens[num - 10];
    else return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
  };
  function handlePDF(e){
    console.log(e)
    const TotalData = {
      sub_total : e.sub_total,
      cess_amt : e.cess,
      gst: e.gst_Amt,
      totalAmount : e.tot,
      roundOff : e.roff,
    }
    const tableData = _.map(e.sales_lines, (val=>({
      pro_name : val.pro_name,
      sale_rate:val.rate,
      qty:val.qty,
      disc1:val.dis_per,
      cgstPerc:val.gst_per,
      cgstAmnt : val.gst_amt,
      totalAmt:val.rate * val.qty,
      hsn: val.hsn,
    })))
    console.log(TotalData)
    axios.post(`/v1/outlet_sales_master/getall`,{docno : e.billNo})
    .then(res=>{
    dispatch(setPDFData({
      tableData : tableData,
      TotalData : TotalData,
      companyInfo : res.data,
      totalText : convertNumber(e.tot),
      title:'Sales Invoice',
      
    }))      
    const name = `BillNo_${e.billNo}`
    navigate(`/invoice/${name}`)  
    })
    .catch(err=>{
      console.log(err)
      dispatch(
        setSnackbar(true, "error", err.response.data.errors[0].message)
      );
    })
    
    
    // dispatch(setPDFData({
    //   tableData : e.purchase_lines,
    //   // TotalData : 
    // }))
    }
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "date1",
    headerName: "Date",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "billNo",
    headerName: "Bill No",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "party",
    headerName: "Outlet Name",
    minWidth: 130,
    headerAlign: "center",
    flex:1,
    align: "center",
    sortable: false,
  },
  {
    field: "mobile",
    headerName: "Mobile",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "amt",
    headerName: "Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "cgst",
    headerName: "CGST",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "sgst",
    headerName: "SGST",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  // {
  //   field: "igst",
  //   headerName: "IGST",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "cess",
  //   headerName: "Cess",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  // {
  //   field: "dis",
  //   headerName: "Dis",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  {
    field: "tot",
    headerName: "Total",
    minWidth: 130,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "view",
    headerName: "View",
    disableExport: true ,
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    renderCell: (params) => {
      return (
        <div>
          <IconButton size="small" onClick={() => onEdit(params)}>
          <VisibilityIcon sx={{fontSize: 18}} />
        </IconButton>
        {/* <IconButton size="small" onClick={()=>handlePDF(params.row)}>
          <PictureAsPdf sx={{fontSize: 18}} />
        </IconButton> */}
        </div>
      );
    },
  },
]

const rows = _.map(data,(val,idx)=>({
  id: val.id,
  sno: idx+1,
  date1 : moment(val.docdate).format("DD-MM-YYYY"),
  billNo : val.docno,
  party : val.fullname || "-",
  amt : val.amount,
  cess : val.cess_amt,
  dis : val.dis_amt || 0,
  tot: parseFloat(val.amount).toFixed(0),
  cgst:parseFloat(val.gst_amt / 2).toFixed(0),
  sgst:parseFloat(val.gst_amt / 2).toFixed(0),
  sales_lines:val.stock_missing_lines,
  tot_amt: val.amount,
  documentNo:val.docno,
  gst_Amt : val.gst_amt,
  roff: val.roff,
  mobile:val.mobile,
  documentDate:moment(val.docdate).format("DD-MM-YYYY"),
  sub_total : parseFloat(val.amount - val.gst_amt - val.cess_amt + val.roff).toFixed(2) ,
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
useEffect(() => {
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.amount);
  });
  setTotalAmount(total.toFixed(0));
}, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data)
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
function handleOutletSalesReport(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
    customer: cust!==null ? cust.id : 0
  }
  axios.post('/v1/reports/stock_missing', postData)
  .then(res=>{
    setData(res.data)
    setPageCount(res.data.length)
  })
  .catch(err=>{
    dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
    setData([])
  })
}
  useEffect(() => {
    getSupplierData();
  }, []);
  
  useEffect(()=>{
    if( dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleOutletSalesReport()
      console.log('Vanthuden')
    }
  },[rowsPerPage, page, dateLimit, cust])
  const tableHeadData = [
    { id:1, label: "S No" },
    { id:2, label: "product name" },
    { id:3 , label:"MRP"},
    { id:4 , label:"Gst Amnt"},
    { id:5, label:"Gst Per"},
    { id:6 , label:"Qty"},
    { id:7 , label:"Rate"},
    {id:8, label: 'Total'}
  ];
  const tableBodyData = _.map(salesLines, (val,idx) => ({
    id:idx,
    sNo:idx+1,
    name:val.barcode,
    docNo:val.docno,
    docDate:moment(val.docdate).format('DD-MM-YYYY'),
    Mrp:val.mrp,
    gstAmnt:val.gst_amt,
    gstPer:val.gst_per,
    Qty:val.qty,
    Rate:val.rate,
    totalAmount : parseFloat( val.qty * val.rate ).toFixed(2)
  }))
  return (
    <Fragment>
      <Helmet><title>Stock missing reports</title></Helmet>
      <Typography variant="h6">Stock missing reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={[{id:0 , fullname : "All"} , ...supplier]}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname} 
            renderInput={(params) => <TextField {...params} label="Select Outlet" />}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'},
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props}/>
      <Backdrop open={open} sx={{zIndex:9999}}>
        <ModalTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop>
    </Fragment>
  );
};

export default StockMissingReports;
